import { useEppoFeatureFlag } from '@/context/hooks/useInitializeEppo';

export const useNewHomepageGetStartedAssignment = () => {
  const { value: newHomepageGetStartedAssignment } = useEppoFeatureFlag({
    featureFlag: 'New-Homepage-Get-Started-Experiment',
    flagType: 'string',
    defaultValue: 'control',
  });

  switch (newHomepageGetStartedAssignment) {
    case 'treatment_a':
    case 'treatment_b':
      return newHomepageGetStartedAssignment;
    default:
      return 'control';
  }
};
